import axios from 'axios';
import { getApiBaseUrl } from 'helpers/api';
import axiosInstance from 'utils/axiosInstance';

const baseUrl = getApiBaseUrl();

export function getMyAgentApi(type: { type: string }) {
  return axiosInstance.get(`/user/getMyAgent?type=${type.type}`);
}

export function getCitiesApi(cityName: string) {
  return axios.get(
    `${baseUrl}/user/citiesCoord?city=${encodeURIComponent(cityName)}`,
  );
}
